
import { styled } from '@mui/system';

const StyledInDevelopment = styled('div', {target: 'InDevelopment'})(({theme}) => ({
    position: 'absolute',
    top:0,
    right: 0,
    padding: theme.spacing(0.5),
    marginTop: theme.spacing(1),
    border: `${'1px solid var(--mui-palette-primary-main)'}`,
    color: `${'var(--mui-palette-primary-main)'}`,
    borderRadius: theme.spacing(0.5)
  }));


export { StyledInDevelopment }